export default {
  en: {
    'pages.filing.summary-page.intrastat-page.status.title':
      'Open / Ready for review / Ready for filing',
  },
};
